import { Fragment } from "react";
import { H5, H6, LI, P, UL } from "../../../AbstractElements";
import { Folders } from "../../../Constant";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";

export const FolderSection = () => {
  const { myFile } = useAppSelector((state) => state.filemanager);

  return (
    <>
      <H5 className="mt-4">{Folders}</H5>
        <UL className="simple-list folder d-flex flex-row flex-wrap">
          {myFile.map((item, index) => (
            <Fragment key={index}>
              {item.title && (
                <LI className="folder-box ms-2" key={index}>
                  <div className="d-block">
                    <i className={item.folderClass}></i>
                    <i className="fa fa-ellipsis-v me-0 f-14 ellips"></i>
                    <div className="mt-3">
                      <H6>{item.title}</H6>
                      <P>
                        {item.folderSize}
                        <span className="pull-right">
                          <i className="fa fa-clock-o"></i>
                          {item.modify}
                        </span>
                      </P>
                    </div>
                  </div>
                </LI>
              )}
            </Fragment>
          ))}
        </UL>
    </>
  );
};
